import { render, staticRenderFns } from "./AdminConfigurePipelineDatasetPage.vue?vue&type=template&id=00cca8c7"
import script from "./AdminConfigurePipelineDatasetPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminConfigurePipelineDatasetPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports